const tableCellGroup = {
  Typography: '¿Realmente desea eliminar este elemento?'
};

export default tableCellGroup;
